<template>
  <v-dialog
    v-model="isOpen"
    :content-class="isClassAdd ? contentClass : 'custom-popup'"
    :width="width"
    :scrim="hideOverlay ? false : true"
    :attach="attach ? attach : false"
    :persistent="persistent"
    @click:outside="onClickOutside"
  >
    <v-icon
      class="custom-popup__close-btn mb-3"
      size="18"
      color="#FFFFFF"
      icon="plusRotate"
      @click="isOpen = false"
    />
    <slot> </slot>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    width: String,
    contentClass: String,
    hideOverlay: Boolean,
    attach: String,
    persistent: Boolean,
  },
  emits: ["update:modelValue"],

  computed: {
    isOpen: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    isClassAdd() {
      if (this.contentClass && this.contentClass.length) {
        return true;
      } else return false;
    },
  },

  watch: {
    modelValue(newVal) {
      if (newVal) {
        document.addEventListener("keydown", this.handleEsc);
      } else {
        document.removeEventListener("keydown", this.handleEsc);
      }
    },
  },

  beforeUnmount() {
    document.removeEventListener("keydown", this.handleEsc);
  },

  methods: {
    handleEsc(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        this.isOpen = false;
      }
    },
    onClickOutside() {
      if (!this.persistent) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style lang="scss">
.custom-popup {
  position: relative;
  overflow-y: visible;
  &__close-btn {
    position: absolute !important;
    right: 0;
    top: -25px;
  }
}
.popup-attached-ovaerlay {
  z-index: inherit;
}
</style>
